<template>
  <div class="vendor-dashboard relative">
    <vendor-floating-nav :vendor-id="vendorId"></vendor-floating-nav>
    <div class="vendor-dashboard-above-content-wrapper container relative" style="height:0;">
      <div class="vendor-dashboard-above-content container">
        <div v-if="backLink" class="vendor-dashboard-backlink text-l">
          <saffron-link :to="backLink">
            <icon-text
              text="justopp.vendorDashboard.backLinkCta"
              icon="chevron-inline-start"></icon-text>
          </saffron-link>
        </div>
      </div>

    </div>
    <div class="container margin-max-top padding-max-bottom">

      <slot></slot>
    </div>
  </div>
</template>

<script>
import VendorFloatingNav from "@/client/applications/justopp/components/nav/VendorFloatingNav";

export default {
  components: { VendorFloatingNav },
  props: {
    vendorId: {
      type: [String, Number],
      default: false,
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.vendor-dashboard-above-content-wrapper {

}
.vendor-dashboard-above-content {
  position: absolute;
  top: var(--margin-m);
  inset-inline-start: 0;
}

// fix icon padding looking misaligned
.vendor-dashboard-backlink {
  position: relative;
  inset-inline-start: calc(var(--margin-m) * -0.7);
}
</style>
